<template>
  <div>
    <div id="/"></div>
    <div
      class="mainDiv"
      v-for="(item, index) in type"
      :key="index"
      :class="sty[index % 2]"
    >
      <mod1 v-if="item.type === 1" :mod1="item.mod" :id="index">
        <div class="fontDiv" v-if="item.display">
          <div class="slot" v-if="item.moduleName || item.moduleEnglish">
            <div :id="index" v-html="item.moduleName"></div>
            <div style="color: #867f7f" v-html="item.moduleEnglish"></div>
            <div class="underline"></div>
          </div>
        </div>
      </mod1>
      <mod2 v-if="item.type === 2" :mod2="item.mod">
        <div class="fontDiv">
          <div class="slot" v-if="item.moduleName || item.moduleEnglish">
            <div :id="index" v-html="item.moduleName"></div>
            <div style="color: #867f7f" v-html="item.moduleEnglish"></div>
            <div class="underline"></div>
          </div>
        </div>
      </mod2>
      <mod3 v-if="item.type === 3" :mod3="item.mod">
        <div class="fontDiv">
          <div class="slot" v-if="item.moduleName || item.moduleEnglish">
            <div :id="index" v-html="item.moduleName"></div>
            <div style="color: #867f7f" v-html="item.moduleEnglish"></div>
            <div class="underline"></div>
          </div>
        </div>
      </mod3>
      <mod4 v-if="item.type === 4" :mod4="item.mod">
        <div class="fontDiv">
          <div class="slot" v-if="item.moduleName || item.moduleEnglish">
            <div :id="index" v-html="item.moduleName"></div>
            <div style="color: #867f7f" v-html="item.moduleEnglish"></div>
            <div class="underline"></div>
          </div>
        </div>
      </mod4>
    </div>
  </div>
</template>

<script>
import mod1 from "./moduleOne/moduleOne";
import mod2 from "./moduleTwo/moduleTwo";
import mod3 from "./moduleThree/moduleThree";
import mod4 from "./moduleFour/moduleFour";
import axios from "axios";
export default {
  data() {
    return {
      type: [],
      companyDto: [], // 顶部底部信息
      sty: ["A", "B"]
    };
  },
  components: {
    mod1,
    mod2,
    mod3,
    mod4
  },
  mounted() {
    this.getHome();
  },
  methods: {
    getHome() {
      // let domain = window.location.href.split("/");  domain[2]
      // let domain = 'www.idoutec.cn'
      let domain = window.location.href.split("/");
      axios.get("/api/home/homepage?companyUrl=" + domain[2], {}).then(res => {
        let list = res.data.data.data;
        this.companyDto = res.data.data.companyDto;
        document.title = this.companyDto.companyName;
        list.forEach(temp => {
          this.type.push({
            type: temp.type,
            display: temp.display,
            moduleName: temp.moduleName,
            moduleEnglish: temp.moduleEnglish,
            moduleUrl: temp.moduleUrl,
            mod: JSON.parse(temp.data)
          });
        });
      });
      // console.log(this.type);
    }
  }
};
</script>

<style lang="sass">
.A
  background: #f9f9f9
.B
  background: #ffffff
.mainDiv
  .fontDiv
    .slot
      text-align: center
      padding: 20px 0
      .underline
        width: 35px
        height: 10px
        border-bottom: 3px solid black
        margin: auto
        padding-right: 3px
      div
        margin: auto 0 0
        font-size: 16pt
</style>
